import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UserInfoService } from 'src/app/shared/services/UserInfoService/user-info.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  mainURL = '';
  baseURL = environment.baseURL;
  constructor(private http: HttpClient, private userInfoService: UserInfoService) {
    this.mainURL = 'api/user/' + this.userInfoService.getUserId() + '/profile/';
  }

  getMyCourses() {
    return this.http.get(this.baseURL + this.mainURL + 'getMyCourses');
  }

  getMyPayments() {
    return this.http.get(this.baseURL + this.mainURL + 'getMyPayments');
  }
}
